import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { reference, studyDetails } from '../data/study';
import { EASE } from '../utils/motion';
type StudyDetailsPanelProps = {
  open: boolean;
  onClose: () => void;
};
export function StudyDetailsPanel({
  open,
  onClose
}: StudyDetailsPanelProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-225" data-mp="2ij0gyqfhxn6r">
      {open && <>
          <motion.div className="absolute inset-0 z-40 bg-black/45" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} onClick={onClose} data-id="element-226" data-mp="1m02xajf1ek0u" />
          <motion.aside role="dialog" aria-modal="true" aria-labelledby="study-details-title" className="absolute inset-y-0 right-0 z-50 flex w-full max-w-md flex-col bg-surface text-ink shadow-[-12px_0_40px_rgba(0,0,0,0.25)]" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} data-id="element-227" data-mp="2p2abtva5w4eo">
            <div className="flex items-center justify-between border-b border-hairline px-6 py-5 sm:px-8 sm:py-6" data-id="element-228" data-mp="26azplrfdsft4">
              <div data-id="element-229" data-mp="21d7w4sz38lmt">
                <p className="text-xs text-muted" data-id="element-230" data-mp="21ej2n0jx47hm">Study details</p>
                <h2 id="study-details-title" className="mt-1 font-display text-2xl tracking-[-0.02em] text-ink" data-id="element-231" data-mp="1wewmai8smb4l">
                  FIBRONEER-IPF
                </h2>
              </div>
              <button ref={closeRef} type="button" onClick={onClose} aria-label="Close study details" className="flex h-10 w-10 items-center justify-center rounded-full text-muted transition-colors duration-150 ease-out hover:bg-ink/5 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-232" data-mp="3qsnx3l2uz11m">
                <XIcon className="h-5 w-5" data-id="element-233" data-mp="1k3vk07tnrum8" />
              </button>
            </div>
            <dl className="flex-1 divide-y divide-hairline overflow-y-auto px-6 sm:px-8" data-id="element-234" data-mp="27u9iag2u6pp9">
              {studyDetails.map(d => <div key={d.title} className="py-5" data-id="element-235" data-mp="2cpyhujeuw6lk">
                  <dt className="text-xs font-medium text-accent" data-id="element-236" data-mp="1xtqpuwx7i0vq">{d.title}</dt>
                  <dd className="mt-1.5 text-[15px] leading-relaxed text-ink" data-id="element-237" data-mp="22tbzq2dwztn8">{d.body}</dd>
                </div>)}
            </dl>
            <p className="border-t border-hairline px-6 py-5 text-xs leading-relaxed text-muted sm:px-8" data-id="element-238" data-mp="me24ub3ijbxk">{reference}</p>
          </motion.aside>
        </>}
    </AnimatePresence>;
}